import { render } from "./SelectorGames.vue?vue&type=template&id=5cb457fd"
import script from "./SelectorGames.vue?vue&type=script&lang=js"
export * from "./SelectorGames.vue?vue&type=script&lang=js"

import "./SelectorGames.vue?vue&type=style&index=0&id=5cb457fd&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__